export const RoleActionTypes = {
  SET_ROLES: 'SET_ROLES',
  SET_ROLE: 'SET_ROLE',
  SET_UNASSIGNED_USERS: 'SET_UNASSIGNED_USERS',
  SET_UNASSIGNED_PAGES: 'SET_UNASSIGNED_PAGES',
  SET_USERS: 'SET_USERS',
  SET_PAGES: 'SET_PAGES'
};
